import { ContractorRole } from '../../enums/users';

/**
 * Numeric (or string) user id from `/users/{firstName}/{id}` or `/user/{firstName}/{id}`.
 * Uses pathname so it stays correct with URL prefixes / basename.
 */
export function parseUsersRouteUserId(pathname: string): string | undefined {
    const usersMatch = pathname.match(/\/users\/[^/]+\/([^/?#]+)\/?$/);
    if (usersMatch?.[1]) return usersMatch[1];
    const userMatch = pathname.match(/\/user\/[^/]+\/([^/?#]+)\/?$/);
    return userMatch?.[1];
}

/** API path for `useGetUserListQuery`, shared by list + stats. */
export function buildUsersListUrl(
    loggedInUser: {
        role?: string;
        company?: number;
    } | null,
): string {
    if (!loggedInUser?.role) return '';
    if (
        loggedInUser.role === 'owner_admin' ||
        loggedInUser.role === 'owner_company'
    ) {
        return `/owners/${loggedInUser.company}/users`;
    }
    if (
        loggedInUser.role === 'guest_admin' ||
        loggedInUser.role === 'guest_company' ||
        loggedInUser.role === 'guest_department_admin'
    ) {
        return `/guests/${loggedInUser.company}/users`;
    }
    if (loggedInUser.role === ContractorRole.Admin) {
        return `/contractors/${loggedInUser.company}/users`;
    }
    return `/7-day/users`;
}
